import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'FileInput',
  props: {
    item: { type: Object, required: true },
    field: { type: String, required: true },
    acceptType: { type: String, required: true },
    errorText: { type: String, required: false },
  },
  emits: ['updateFile'],
  setup(props, { emit }) {
    const fileInput = ref<HTMLElement | null>(null)
    const openFile = () => {
      fileInput.value?.click()
    }
    const handleFileChange = (event: Event) => {
      const files = (event.target as HTMLInputElement)?.files
      emit('updateFile', props.field, files?.length ? files[0] : null)
    }
    const deleteFile = () => {
      emit('updateFile', props.field, null)
    }
    return {
      deleteFile,
      openFile,
      handleFileChange,
    }
  },
})
